import React from 'react';
import { ARROW_MARKER_STYLES } from './skillTreeStyles';

/**
 * Shared arrowhead markers. The outline silhouette rides the link-outline path and the plain
 * gray arrow rides the link-stroke path above it, so line and arrow share one continuous rim
 * instead of the arrow carrying its own crossing outline.
 */
export const ArrowMarkerDefs: React.FC = () => {
    const sharedMarkerAttrs = {
        viewBox: ARROW_MARKER_STYLES.viewBox,
        refX: ARROW_MARKER_STYLES.refX,
        refY: ARROW_MARKER_STYLES.refY,
        markerWidth: ARROW_MARKER_STYLES.markerWidth,
        markerHeight: ARROW_MARKER_STYLES.markerHeight,
        orient: ARROW_MARKER_STYLES.orient,
        markerUnits: "userSpaceOnUse", // Fixed size, doesn't inherit stroke width
        // Markers clip to their viewport by default, which would shear the outline
        // silhouette's rim where it extends past the viewBox at the arrow point.
        style: { overflow: 'visible' },
    } as const;
    return (
        <svg style={{ position: 'absolute', width: 0, height: 0 }}>
            <defs>
                <marker id={ARROW_MARKER_STYLES.outlineId} {...sharedMarkerAttrs}>
                    <path
                        d={ARROW_MARKER_STYLES.path}
                        fill={ARROW_MARKER_STYLES.colors.stroke}
                        stroke={ARROW_MARKER_STYLES.colors.stroke}
                        strokeWidth={ARROW_MARKER_STYLES.outlineStrokeWidth}
                    />
                </marker>
                <marker id={ARROW_MARKER_STYLES.id} {...sharedMarkerAttrs}>
                    <path d={ARROW_MARKER_STYLES.path} fill={ARROW_MARKER_STYLES.colors.fill} />
                </marker>
            </defs>
        </svg>
    );
};
